import React, {useEffect, useLayoutEffect, useState, useMemo, useReducer, useContext} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import OrderService from '../services/OrderService';
import {MaterialReactTable} from 'material-react-table';
import {Alert, Box, Button, ListItemIcon, MenuItem, Snackbar, Typography} from '@mui/material';
import {Context} from '../index';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import EntityList from "../components/EntityList";
import {toJS} from "mobx";
import MyButton from "../UI/MyButton/MyButton";
import ConsignmentConverter from '../utils/ConsignmentConverter';
import CorrectionNotice from '../components/CorrectionNotice';
import CorrectionChangesModal from '../components/CorrectionChangesModal';
import { READY_BUTTONS, STATES } from '../config';

/**
 * выводить:
 * имя, дату, способ доставки, позиции
 * name, moment/created?, attributes.find(attribute => attribute.name == 'Способ доставки NEW').value, positions
 */

const sleep = (ms) => new Promise(r => setTimeout(r, ms));
// Сколько раз и с каким интервалом спрашивать статус джоба печати ШК
// (принт-агент на ПК с принтером поллит бэкенд раз в 2с)
const PRINT_STATUS_ATTEMPTS = 8;
const PRINT_STATUS_DELAY = 2000;

export default function OrderById() {
    const {store} = useContext(Context);
    const pagination = {
        pageSize: 100
    }
    // Use config for buttons and states (supports multi-instance deployment)
    const readyButtons = READY_BUTTONS;
    const STATES_MAP = STATES;
    const [order, setOrder] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    let [barcodeParts, setBarcodeParts] = useState('');
    const [barcode, setBarcode] = useState({});
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const params = useParams();
    const [showPopup, setShowPopup] = useState(false);
    const [isWaitingButtonClicked, setIsWaitingButtonClicked] = useState(false);
    const [isCorrectButtonClicked, setIsCorrectButtonClicked] = useState(false);
    const [orderCorrectReason, setOrderCorrectReason] = useState("");
    const [orderWaitingReason, setOrderWaitingReason] = useState("");
    const [scannedConsignments, setScannedConsignments] = useState({});
    // Модалка «после корректировки»: открывается при каждой загрузке заказа,
    // вернувшегося из «Корректировок» и ещё не собранного - флаг afterCorrection
    // от бэкенда живёт до статуса «Собрано», включая время «На сборке».
    // При пустом диффе позиций не открывается - причину корректировки
    // показывает баннер CorrectionNotice.
    const [showChangesModal, setShowChangesModal] = useState(false);
    // Печать ШК-этикетки: джоб уходит на бэкенд, забирает принт-агент на ПК с принтером
    const [printPending, setPrintPending] = useState(false);
    const [printError, setPrintError] = useState(null);
    const [printUnavailable, setPrintUnavailable] = useState(false);
    const navigate = useNavigate();
    const columns = useMemo(
        () => [
            {
                accessorKey: 'image',
                header: 'Изображение',
                size: 200,
                Cell: ({cell}) => (
                    <img
                        alt="No image"
                        src={cell.getValue()}/>
                )
            },
            {
                accessorKey: 'article',
                header: 'Артикул',
                size: 200
            },
            {
                accessorKey: 'name',
                header: 'Наименование',
                size: 200,
                Cell: ({ row }) => {
                    const item = row.original;
                    const hasConsignment = item.type === 'consignment' && item.consignmentLabel;

                    return (
                        <div>
                            <div>{item.name}</div>
                            {hasConsignment && (
                                <div style={{
                                    display: 'inline-block',
                                    marginTop: '4px',
                                    padding: '2px 8px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: '#1565c0',
                                    backgroundColor: '#e3f2fd',
                                    border: '1px solid #90caf9',
                                    borderRadius: '4px'
                                }}>
                                    Серия: {item.consignmentLabel}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                accessorKey: 'quantity',
                header: 'Количество',
                size: 200,
                Cell: ({cell}) => (
                    <span style={{fontSize: '20px'}}>
                        {cell.getValue()}
                    </span>
                )
            }
        ],
        [],
    );

    useEffect(() => {
        getOrderById(params.id);
        uploadSelectedRowsFromServer();

    }, [params.id])

    async function uploadSelectedRowsFromServer() {
        try {
            const response = await store.checkEntitiesInWork();

            const orderInStore = toJS(store.entitiesInWork);
            const rowsToUpdate = orderInStore.find(item => item.id === params.id).selectedPositions;

            console.log('order in store', rowsToUpdate)

            setRowSelection({...rowsToUpdate});

        } catch (e) {
            console.log(e);
        }
    }


    useEffect(() => {
        console.log(rowSelection);
        const orderInStoree = updateSelectedPositions();

    }, [rowSelection])

    async function updateSelectedPositions() {
        const updateRows = Object.assign({}, rowSelection);
        console.log('updateRows', updateRows);
        let serverResToUpdateSelectedPositions;
        if (Object.keys(updateRows).length > 0) {
            await OrderService.updateSelectedPositions(params.id, {updateRows});
        }

        return serverResToUpdateSelectedPositions;
    }

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.key === 'Enter') {
                setBarcode({value: parseScannedInput(barcodeParts)});
                setBarcodeParts('');
                return;
            }

            let newBarcode = barcodeParts.concat(e.key);
            setBarcodeParts(newBarcode);
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [barcodeParts]);

    useEffect(() => {
        if (order.length !== 0) {
            console.log('order', order);

            // Сначала ищем среди обычных штрихкодов
            let scannedProduct = order.positions.find(position => position.barcode === barcode.value);

            // Если не найдено - ищем среди штрихкодов серий (consignmentBarcode)
            if (!scannedProduct) {
                scannedProduct = order.positions.find(position =>
                    position.consignmentBarcode === barcode.value &&
                    position.type === 'consignment'
                );
            }

            console.log(barcode.value);
            console.log(scannedProduct);

            if (!scannedProduct) {
                setBarcodeParts('');
                setShowPopup(true);
                return;
            }

            // Проверка на повторное сканирование той же серии
            if (scannedProduct.type === 'consignment') {
                if (scannedConsignments[scannedProduct.id]) {
                    setBarcodeParts('');
                    setShowPopup(true);
                    return;
                }
                // Отмечаем серию как отсканированную
                setScannedConsignments(prev => ({
                    ...prev,
                    [scannedProduct.id]: true
                }));
            }

            // Один и тот же товар может идти и отдельной позицией, и компонентом
            // комплекта: строк две, штрихкод один. Отмечаем все строки с этим
            // штрихкодом, иначе вторая не отметится сканом и заблокирует «Собрано».
            const scannedRows = order.positions.filter(position => position.barcode === barcode.value);
            const rowsToSelect = scannedRows.length > 0 ? scannedRows : [scannedProduct];
            const selectedRow = Object.assign(rowSelection);
            for (const rowToSelect of rowsToSelect) {
                selectedRow[rowToSelect.id] = true;
            }
            setRowSelection((selectedRow) => (selectedRow));
            console.log('selected row', selectedRow);
        }
        forceUpdate();
    }, [barcode])

    async function getOrderById(id) {
        let orderIsTaken = false;
        while (!orderIsTaken) {
            try {
                const response = await OrderService.getOrderById(id);
                console.log(response);

                setOrder(response.data);
                // Модалка - только если дифф непустой. Когда правили не позиции
                // (канал продаж, адрес и т.п.), блокировать сборщика попапом
                // «Изменений в позициях нет» не нужно: причину уже показывает
                // баннер CorrectionNotice из description.
                const changes = response.data?.correctionChanges;
                const hasPositionChanges =
                    (changes?.added?.length || 0)
                    + (changes?.removed?.length || 0)
                    + (changes?.changed?.length || 0) > 0;
                setShowChangesModal(
                    response.data?.afterCorrection === true && hasPositionChanges
                );
                orderIsTaken = true;

            } catch (e) {
                console.log(e);

                if (e.response?.status === 410) {
                    const errorData = e.response.data;
                    alert(`${errorData.message || 'Заказ уже завершен'}`);

                    navigate('/start');
                    return;
                }
            }
        }
    }

    function parseScannedInput(input) {
        const matches = input.match(/Alt(\d+)/g);
        if (!matches) return input;

        return matches.map((code) => {
            const num = code.replace("Alt", "");
            return String.fromCharCode(parseInt(num));
        }).join('');
    }

    // Печать ШК-этикетки заказа (принт-агент на ПК с принтером, ~2-4с после нажатия).
    // Об успехе молчим - наклейка сама подтверждение; ошибку агента показываем тостом.
    async function handlePrintBarcode() {
        if (printPending) return;
        setPrintPending(true);
        setPrintError(null);
        try {
            const {data: created} = await OrderService.printBarcodeLabel(params.id, order.name);
            for (let i = 0; i < PRINT_STATUS_ATTEMPTS; i++) {
                await sleep(PRINT_STATUS_DELAY);
                let status;
                try {
                    const response = await OrderService.getPrintJobStatus(created.jobId);
                    status = response.data;
                } catch (err) {
                    if (err.response?.status !== 404) throw err;
                    continue;
                }
                if (status.status === 'printed') return;
                if (status.status === 'failed') throw new Error(status.error || 'ошибка печати на принтере');
            }
            throw new Error('принтер выключен или программа для печати не запущена');
        } catch (error) {
            if (error.response?.status === 503) {
                setPrintUnavailable(true);
                setPrintError('Печать этикеток не настроена, обратитесь к администратору');
            } else {
                const detail = error.response?.data?.message || error.message;
                setPrintError(`Этикетка не напечаталась: ${detail}. Проверьте принтер и нажмите ещё раз.`);
            }
        } finally {
            setPrintPending(false);
        }
    }

    const handleSendToCorrect = async () => {
        if (!orderCorrectReason.trim()) {
            alert('Укажите причину корректировки');
            return;
        }
        try {
            const result = await OrderService.changeOrderStatus(params.id, 'Корректировки', orderCorrectReason);
            console.log(result);
            console.log(store.user.id);
            const serverRes = await OrderService.moveOrderToWaitingList(params.id, 'correct', orderCorrectReason);
            alert(`Заказ покупателя ${order.name} успешно отправлен на корректировку!`)
            navigate('/start')

        } catch (error) {
            alert(`Ошибка! Что-то пошло не так...\n${error.message}`)
        }
    };

    const handleToWaitingList = async () => {
        const serverRes = await OrderService.moveOrderToWaitingList(params.id, 'waiting', orderWaitingReason);
        alert(`Заказ покупателя ${order.name} успешно отправлен в лист ожидания!`)
        navigate('/start');
    };


    return (
        <div>
            {order?.positions
                ?
                <>
                {/* Был ли заказ на корректировке - по записям [КОРРЕКТИРОВКА ...]
                    в description. Видно до начала сборки, закрытие - на просмотр. */}
                <CorrectionNotice description={order.description} />
                <MaterialReactTable columns={columns} data={order.positions}
                                    enableRowSelection
                                    enableSelectAll={false}
                                    onRowSelectionChange={setRowSelection}
                                    initialState={{pagination}}
                                    getRowId={(originalRow)=> originalRow.id}
                                    state={{rowSelection}}
                                    renderTopToolbarCustomActions={({table}) => {
                                        const handleCollectOrder = async () => {
                                            try {
                                                const result = await OrderService.changeOrderStatus(params.id, STATES_MAP.get(store.user.position));
                                                console.log(result);
                                                const removeOrderFromWork = await OrderService.removeOrderFromWork(params.id, store.user.position);
                                                console.log(removeOrderFromWork)
                                                alert(`Заказ покупателя ${order.name} переведен на статус ${STATES_MAP.get(store.user.position)}!`)
                                                navigate('/start')
                                            } catch (error) {
                                                alert(`Ошибка! Что-то пошло не так...\n${error.message}`)
                                            }
                                        };

                                        return (
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginTop: 9,
                                                    marginLeft: 35,
                                                    whiteSpace: 'pre-line'
                                                }}>Комментарий: <b>{order.description}</b></div>
                                                {order.extraComment && (
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Комментарий к заказу: <b>{order.extraComment}</b></div>
                                                )}
                                                <div style={{display: 'flex', gap: '0.5rem'}}>
                                                    <Button
                                                        color="success"
                                                        disabled={!table.getIsAllRowsSelected()}
                                                        onClick={handleCollectOrder}
                                                        variant="contained"
                                                    >
                                                        {readyButtons[store.user.position]}
                                                    </Button>
                                                    <Button
                                                        color="error"
                                                        onClick={() => setIsCorrectButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        КОРРЕКТИРОВКА
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => setIsWaitingButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        В ожидание
                                                    </Button>
                                                    {store.positionKey === 'assembler' && !printUnavailable && (
                                                        <Button
                                                            color="secondary"
                                                            disabled={printPending || !order.name}
                                                            onClick={handlePrintBarcode}
                                                            variant="contained"
                                                        >
                                                            {printPending ? 'ПЕЧАТЬ...' : 'РАСПЕЧАТАТЬ ШК'}
                                                        </Button>
                                                    )}
                                                </div>
                                                <div style={{display: "flex"}}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Заказ: <b>{order.name}</b></div>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>Способ доставки: <b>{order.delivery}</b></div>
                                                </div>
                                            </div>
                                        );
                                    }}
                />
                </>
                :
                ""}
            <Popup open={showPopup} onClose={() => setShowPopup(false)}><h4> Неверный штрихкод! </h4></Popup>
            <Snackbar
                open={Boolean(printError)}
                autoHideDuration={10000}
                onClose={() => setPrintError(null)}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            >
                <Alert
                    onClose={() => setPrintError(null)}
                    severity="error"
                    variant="filled"
                >
                    {printError}
                </Alert>
            </Snackbar>
            <Popup open={isCorrectButtonClicked} onClose={() => setIsCorrectButtonClicked(false)}>
                <h2> Укажите причину корректировки </h2>
                <input
                    onChange={(e) => {
                        setOrderCorrectReason(e.target.value)
                    }}
                    name={"correct_reason"}
                    value={orderCorrectReason}
                    type="text"
                    placeholder='причина корректировки'
                />
                <small style={{display: 'block', color: '#888', marginTop: 4}}>
                    Поле обязательно для корректировки
                </small>
                <MyButton
                    disabled={!orderCorrectReason.trim()}
                    onClick={() => handleSendToCorrect()}
                >
                    Отправить
                </MyButton>
            </Popup>
            <Popup open={isWaitingButtonClicked} onClose={() => setIsWaitingButtonClicked(false)}>
                <h2> Укажите причину ожидания </h2>
                <input
                    onChange={(e) => {
                        setOrderWaitingReason(e.target.value)
                    }}
                    name={"waiting_reason"}
                    value={orderWaitingReason}
                    type="text"
                    placeholder='причина ожидания'
                />
                <MyButton onClick={() => handleToWaitingList()}> Отправить </MyButton>
            </Popup>
            {/* Loading component */}
            <CorrectionChangesModal
                open={showChangesModal}
                onClose={() => setShowChangesModal(false)}
                changes={order?.correctionChanges}
            />
        </div>
    )
}
